

import React, { useState } from 'react';

// VehicleBlock component
const VehicleBlock = ({ imgSrc, title, onBook, seats, fuelTypes, bags }) => {
  const allFuelTypes = ['Petrol', 'Diesel', 'CNG'];

  return (
    <div className="col-lg-4 col-md-6 m-b30">
      <div className="vehicle-card">
        {/* Car Image */}
        <div className="vehicle-img">
          <img src={imgSrc} alt={title} />
        </div>

        {/* Content */}
        <div className="vehicle-content">
          <h3 className="vehicle-title">{title}</h3>
          <ul className="vehicle-facility">
            <li>
              <img src="images/icons/car-seat.png" alt="seat" /> {seats} Seats
            </li>
            <li>
              <img src="images/icons/bag.png" alt="bags" /> {bags} Bags
            </li>
          </ul>

          <ul className="vehicle-fuel">
            {allFuelTypes.map((type) => (
              <li
                key={type}
                className={fuelTypes.includes(type) ? 'active' : 'disabled'}
              >
                {type}
              </li>
            ))}
          </ul>

          <div className="text-center py-3">
            <button className="btn-book" onClick={() => onBook(title)}>
              Book Now
            </button>
          </div>
        </div>

       
      </div>
    </div>
  );
};

// Booking component
const Booking = () => {
  const [bookingMessage, setBookingMessage] = useState('');

  const vehicles = [
    {
      imgSrc: '/images/gallery/1.jpg',
      price: 800,
      title: 'SWIFT DZIRE',
      link: 'our-fleet',
      seats: 4,
      bags: 2,
      fuelTypes: ['Petrol','CNG']
    },
     {
      imgSrc: '/images/gallery/21.avif',
      price: 800,
      title: 'Aura',
      link: 'our-fleet',
      seats: 4,
      bags: 2,
      fuelTypes: ['Petrol','CNG']
    },
    {
      imgSrc: '/images/gallery/2.jpg',
      price: 800,
      title: 'ERTIGA',
      link: 'our-fleet',
      seats: 7,
      bags: 2,
      fuelTypes: ['Petrol','CNG']
    },
    {
      imgSrc: '/images/gallery/3.jpg',
      price: 800,
      title: 'INNOVA CRYSTA',
      link: 'our-fleet',
      seats: 7,
      bags: 4,
      fuelTypes: ['Diesel']
    },
    {
      imgSrc: '/images/gallery/19.jpg',
      price: 800,
      title: 'Scorpio',
      link: 'our-fleet',
      seats: 8,
      bags: 4,
      fuelTypes: ['Diesel']
    },


     {
      imgSrc: '/images/gallery/20.jpg',
      price: 800,
      title: 'Tavera',
      link: 'our-fleet',
      seats: 8,
      bags: 4,
      fuelTypes: ['Diesel']
    },
        {
      imgSrc: '/images/gallery/14.jpeg',
      price: 800,
      title: 'Cruiser ',
      link: 'our-fleet',
      seats: 13,
      bags: 4,
      fuelTypes: ['Diesel']
    },
    
    {
      imgSrc: '/images/gallery/4.jpg',
      price: 800,
      title: 'TEMPO TRAVELLER',
      link: 'our-fleet',
      seats: 17,
      bags: 8,
      fuelTypes: ['Diesel']
    },
    {
      imgSrc: '/images/gallery/5.jpg',
      price: 800,
      title: 'TEMPO TRAVELLER',
      link: 'our-fleet',
      seats: 20,
      bags: 8,
      fuelTypes: ['Diesel']
    },
       
    // {
    //   imgSrc: '/images/gallery/6.jpg',
    //   price: 800,
    //   title: 'MINI BUS',
    //   link: 'our-fleet',
    //   seats: 32,
    //   bags: 8,
    //   fuelTypes: ['Diesel']
    // },
    // {
    //   imgSrc: '/images/gallery/7.jpg',
    //   price: 800,
    //   title: 'AC BUS',
    //   link: 'our-fleet',
    //   seats: 45,
    //   bags: 8,
    //   fuelTypes: ['Diesel']
    // },
    // {
    //   imgSrc: '/images/gallery/8.jpg',
    //   price: 800,
    //   title: 'AC BUS',
    //   link: 'our-fleet',
    //   seats: 50,
    //   bags: 8,
    //   fuelTypes: ['Diesel']
    // },
    // {
    //   imgSrc: '/images/gallery/9.jpg',
    //   price: 800,
    //   title: 'AC BUS',
    //   link: 'our-fleet',
    //   seats: 52,
    //   bags: 8,
    //   fuelTypes: ['Diesel']
    // },


  ];

  const handleBooking = (vehicleTitle) => {
    const phoneNumber = '7507048333';
    const message = `Hi, I would like to proceed with booking the ${vehicleTitle} for rent. Please confirm the availability. Looking forward to your confirmation and further details to complete the booking process.`;
    const encodedMessage = encodeURIComponent(message);
    window.open(`https://wa.me/${phoneNumber}?text=${encodedMessage}`, '_blank');
  };

  return (
    <div>
     
 <div
      className="breadcumb-wrapper"
      // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
    >
      <div className="container z-index-common">
        <div className="breadcumb-content">
          <h1 className="breadcumb-title">Booking</h1>
          <div className="breadcumb-menu-wrap">
          </div>
        </div>
      </div>
    </div>


      {/* Vehicle List Section */}
      <div className="section-full p-t150 p-b120 site-bg-white twm-cars-section-wrap pt-5">
        <div className="container">
          <div className="section-content">
            <div className="twm-cars-section m-b30">
              <div className="row">
                {vehicles.map((vehicle, index) => (
                  <VehicleBlock
                    key={index}
                    imgSrc={vehicle.imgSrc}
                    title={vehicle.title}
                    onBook={handleBooking}
                    seats={vehicle.seats}
                    fuelTypes={vehicle.fuelTypes}
                    bags={vehicle.bags} // ✅ different bags per vehicle
                  />
                ))}
              </div>
            </div>
            {bookingMessage && (
              <div className="booking-message">
                <p>{bookingMessage}</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Booking;
